import {Popup} from "./Popup";

export class CallbackButton {
    protected trigger: string;
    protected popup: Popup;
    protected cookie: string;

    constructor(trigger: string, popup: Popup, cookie: string) {
        this.trigger = trigger;
        this.popup = popup;
        this.cookie = cookie;
        this.init();
    }

    init() {
        const trigger = document.querySelector(this.trigger);
        if (trigger && localStorage.getItem(this.cookie) === `1` || !+window.theme.settings.cookie) {
            setTimeout( () => {
                trigger.classList.add(`is-active`);
                this.popup.addTriggers(this.trigger);
            }, 3000)
        }
    }
}